import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformApis } from '../data/overview';

export const PlatformApis: React.FC = () => (
  <SiteSection id="apis-integrations" tone="muted">
    <SiteSectionHeader
      title={platformApis.title}
      subtitle={platformApis.subtitle}
      align="center"
    />
    <div className="platform-apis">
      <div className="platform-apis__pills">
        {platformApis.integrations.map((name) => (
          <span key={name} className="platform-apis__pill">
            {name}
          </span>
        ))}
      </div>
      <div className="platform-apis__code-grid">
        {platformApis.snippets.map((snippet) => (
          <div key={snippet.id} className="platform-code-block">
            <div className="platform-code-block__header">
              <span className="platform-code-block__dots" aria-hidden>
                <span />
                <span />
                <span />
              </span>
              <span className="platform-code-block__label">{snippet.label}</span>
            </div>
            <pre className="platform-code-block__pre">
              <code>{snippet.code}</code>
            </pre>
          </div>
        ))}
      </div>
    </div>
  </SiteSection>
);
